import React from "react";
import { Routes, Route,Navigate, useLocation } from "react-router-dom";
import MainLayout from '../Layout/MainLayout';
import HomeLayout from '../Layout/HomeLayout';
import SignIn from "../pages/SignIn/SignIn";
// import ForgotPassword from '../pages/SignIn/ForgotPassword';
// import ResetPassword from '../pages/SignIn/ResetPassword';
// import ChangePassword from '../pages/SignIn/ChangePassword';
import Profile from '../pages/Profile';
import Dashboard from '../pages/Dashboard';
import HomePage from '../pages/HomePage';
import Gallery from '../pages/Gallery';
import BusinessUnitDetail from '../pages/BusinessUnits';
import CreateBusinessUnit from '../pages/BusinessUnits/CreateBusinessUnit';
import EditBusinessUnit from '../pages/BusinessUnits/EditBusinessUnit';
import ViewBusinessUnit from '../pages/BusinessUnits/ViewBusinessUnit';
import UserManagement from '../pages/UserManagement';
import CharitableActivity from '../pages/CharitableActivity';
import CreateUser from '../pages/UserManagement/CreateUser';
import EditUser from '../pages/UserManagement/EditUser';
import ViewUser from '../pages/UserManagement/ViewUser';
import CreateCharitableActivity from '../pages/CharitableActivity/CreateCharitableActivity';
import ViewCharitableActivity from '../pages/CharitableActivity/ViewCharitableActivity';
import EditCharitableActivity from '../pages/CharitableActivity/EditCharitableActivity';
// import ProtectedRoute from "./ProtectedRoute";
// import UnProtectedRoute from "./UnProtectedRoute";
import UserManual from  '../pages/UserManual';
import AuditLog from  '../pages/AuditLog';
import ScrollToTop from '../components/ScrollToTop';
import { useMsal } from "@azure/msal-react";
import { azureLogOut } from "../store/actions/auth";
import NotFound from './NotFound';


const wrapWithLayout = (comp) => {
  return <MainLayout>{comp}</MainLayout>
}
const wrapWithHomeLayout = (comp) => {
  return <HomeLayout>{comp}</HomeLayout>
}

const AppRoutes = () => {
  const auth = JSON.parse(window.localStorage.getItem('userInfo')) || JSON.parse(window.sessionStorage.getItem('userInfo'))
  const roleID = auth?.roleId;
  const currentLocation = useLocation(); // Renamed variable
  const { instance } = useMsal();
  window.addEventListener("storage", (event) => {
    if (event.key === "isLogout") {
      window.sessionStorage.clear();
      window.location.href = "/login"; // Update with your login page route
    }
  });
  if (window.localStorage.getItem("isLogout") === "true") {
    azureLogOut(instance)
    sessionStorage.clear();
    localStorage.clear();
  }

  // if(!auth) {
  //   return (
  //     <Routes>
  //       <Route path="/login" element={<SignIn />} />
  //       <Route path="/" element={<SignIn />} />
  //       <Route path="*" element={<Navigate to="/login" />} />
  //     </Routes>
  //   )
  // }
  return (
    <>
    <ScrollToTop />
    <Routes>
      <Route path="/" element={<SignIn />} />
      {/* <Route path="/forgot-password" element={<ForgotPassword />} />
    <Route path="/reset-password" element={<ResetPassword />} />
    <Route path="/change-password" element={wrapWithLayout(<ChangePassword />)} /> */}
      {auth && (
            <Route path="/home" element={wrapWithHomeLayout(<HomePage />)} />
      )}
      {auth?.isProfileExist && !auth?.isUserInActive && (
        <> 
          <Route path="/profile" element={wrapWithLayout(<Profile />)} />
          <Route path="/gallery" element={wrapWithLayout(<Gallery />)} />
          <Route exact path="/dashboard" element={wrapWithLayout(<Dashboard />)} />
          {roleID === 201 && (
            <>
              <Route exact path="/business-units" element={wrapWithLayout(<BusinessUnitDetail />)} />
              <Route exact path="/create-businessunit" element={wrapWithLayout(<CreateBusinessUnit />)} />
              <Route exact path="/edit-businessunit/:name" element={wrapWithLayout(<EditBusinessUnit />)} />
              <Route exact path="/view-businessunit/:name" element={wrapWithLayout(<ViewBusinessUnit />)} />
              <Route exact path="/user-management" element={wrapWithLayout(<UserManagement />)} />
              <Route exact path="/create-user" element={wrapWithLayout(<CreateUser />)}  />
              <Route exact path="/edit-user/:id" element={wrapWithLayout(<EditUser />)} />
              <Route exact path="/view-user/:id" element={wrapWithLayout(<ViewUser />)} />
              <Route path="/audit-log" element={wrapWithLayout(<AuditLog />)} />
            </>
          )}
          <Route exact path="/charitable-activity" element={wrapWithLayout(<CharitableActivity />)} />
          <Route exact path="/create-charitable-activity" element={wrapWithLayout(<CreateCharitableActivity />)} />
          <Route exact path="/edit-charitable-activity/:id" element={wrapWithLayout(<EditCharitableActivity />)} />
          <Route exact path="/view-charitable-activity/:id" element={wrapWithLayout(<ViewCharitableActivity />)} />
          <Route path="/user-manual" element={wrapWithLayout(<UserManual />)} />
        </> 
       )}
      <Route path="/signout" element={<Navigate to="/login" />} />
      <Route path="/login" element={<SignIn />} />
      {currentLocation.pathname !== "/home" && (
        <Route path="*" element={<NotFound />} />
      )}
    </Routes></>
  )
};


export default AppRoutes;